import { gql } from '@apollo/client';

export const QUERY_ACADEMIES = gql`
  query QueryAcademies {
    academies {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;
